import React, { useState } from 'react';
import Container from 'src/components/shared/Container';
import { Spinner } from 'flowbite-react';
import { CandidatesTabsEnum } from 'src/components/recruiterPositions/RecruiterCandidatesContainer2';
import { TypeOfUsers } from 'types';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useGetCampusHiringApplicationsWithCandidates } from 'src/hooks/campusHiring.hooks';
import CandidateList from 'src/components/newRecruiterFlow/campus/campusCandidateListing/CandidateList';
import CandidateFilters from 'src/components/newRecruiterFlow/campus/campusCandidateListing/CandidateFilters';
import HiringAssessmentCandidatesHeader from './HiringAssessmentCandidatesHeader';
import NewCreatingPositionLoader from 'src/components/position/NewCreatingPositionLoader';
import { RiPieChartFill } from 'react-icons/ri';
import { GiHamburgerMenu } from 'react-icons/gi';

const HiringAssessmentCandidateListing = () => {
	const { id: hiringAssessmentId } = useParams();
	const navigate = useNavigate();

	const { id } = useParams();
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [searchParams, setSearchParams] = useSearchParams();
	const search = searchParams.get('search') || '';
	const defaultTab = searchParams.get('tab') || '';
	const [tab, setTab] = useState((defaultTab as CandidatesTabsEnum) || CandidatesTabsEnum.CONNECTED);
	const [bulkSelectedCandidates, setBulkSelectedCandidates] = React.useState<string[]>([]);

	const {
		data: applicationsData,
		isFetching: applicationLoading,
		isLoading,
	} = useGetCampusHiringApplicationsWithCandidates({
		page,
		search: search,
		limit: rowsPerPage,
		hiringAssessment: id || '',
		filters: {
			status: JSON.parse(searchParams.get('status') || '[]'),
			skills: JSON.parse(searchParams.get('skills') || '[]'),
			salary: JSON.parse(searchParams.get('salary') || '[]'),
			matchedPercentaile: JSON.parse(searchParams.get('matchedpercentilefilter') || '[]'),
		},
	});

	const totalShortlistedCandidates = applicationsData?.total || 0;

	const handleUserList = () => {
		navigate(`/recruiter-dashboard/hiring-assessment-list/${hiringAssessmentId}`);
	};
	const handleUsersGraph = () => {
		navigate(`/recruiter-dashboard/hiring-assessment-graph/${hiringAssessmentId}`);
	};

	return (
		<Container>
			<div>
				<div className="flex justify-between items-center border-b border-[#EBEBF0] dark:border-[#555770] border-solid">
					<div>
						<HiringAssessmentCandidatesHeader />
					</div>
					<div className="inline-flex w-[84px] h-[32px] rounded-md border border-[#E4E4EB] bg-white shadow-sm overflow-hidden mt-[24px] sm:hidden">
						<button
							onClick={handleUsersGraph}
							className="flex items-center justify-center w-1/2 h-full border-r border-[#E4E4EB] transition-colors hover:bg-gray-50 focus:outline-none "
							aria-label="View chart"
						>
							<RiPieChartFill className="h-4 w-4 text-slate-600" />
						</button>
						<button
							onClick={handleUserList}
							className="flex items-center justify-center w-1/2 h-full transition-colors hover:bg-gray-50 focus:outline-none "
							aria-label="Open menu"
						>
							<GiHamburgerMenu className="h-4 w-4 text-slate-600" />
						</button>
					</div>
				</div>
			</div>
			<div className="mt-[10px]">
				<CandidateFilters
					selectedTab={tab}
					resetPage={() => setPage(0)}
					typeOfUsers={TypeOfUsers.ASSESSMENT}
					isApplicationApiLoading={!!(search && applicationLoading)}
					bulkSelectedCandidates={bulkSelectedCandidates}
					setBulkSelectedCandidates={setBulkSelectedCandidates}
					candidates={applicationsData?.campusHiringApplications || []}
				/>
			</div>
			{isLoading || applicationLoading ? (
				<div className="mt-[22px] flex items-center justify-center h-[50vh]">
					{/* <Spinner /> */}
					<NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="!w-[30%] mx-auto" />
				</div>
			) : (
				<div className="mt-[22px] pb-5">
					<CandidateList
						page={page}
						setPage={setPage}
						selectedTab={tab}
						showCandidateName={false}
						rowsPerPage={rowsPerPage}
						setRowsPerPage={setRowsPerPage}
						typeOfUsers={TypeOfUsers.ASSESSMENT}
						count={applicationsData?.total || 0}
						bulkSelectedCandidates={bulkSelectedCandidates}
						setBulkSelectedCandidates={setBulkSelectedCandidates}
						candidates={applicationsData?.campusHiringApplications || []}
						totalShortlistedCandidates={totalShortlistedCandidates}
					/>
				</div>
			)}
		</Container>
	);
};

export default HiringAssessmentCandidateListing;
